import { Cluster } from '@cast/types';

import { useIsClusterDemoMode } from '@cast/infrastructure-demo';
import { PRODUCT_BASE_PATHS } from '@cast/console-constants';
import { isDisconnectedForMonth } from 'features/cluster';

import { SidebarItem, SidebarItemProps } from '../../_components/SidebarItem';

import {
  isClusterOnboardingPhase2,
  isClusterManaged,
} from '@cast/shared-cluster-context-data-access';

const useSettingsSidebarItemProps = (
  cluster: Cluster
): Partial<SidebarItemProps> => {
  const isManaged = isClusterManaged(cluster);
  const isDisconnected = cluster && isDisconnectedForMonth(cluster);
  const isClusterDemoMode = useIsClusterDemoMode();

  if (!isClusterDemoMode && isDisconnected) {
    return {
      disabled: true,
      tooltip: 'Enable cost optimization',
    };
  }

  if (
    !isClusterDemoMode &&
    cluster &&
    isClusterOnboardingPhase2(cluster.status, isManaged)
  ) {
    return {
      disabled: true,
      tooltip: 'Invalid cluster status, cluster must be in ready state',
    };
  }

  return {
    disabled: false,
  };
};

type Props = {
  cluster: Cluster;
};

export const SettingsSidebarItem = (props: Props) => {
  const basePath = `${PRODUCT_BASE_PATHS.automation}/external-clusters/${props.cluster.id}`;
  const sidebarItemProps = useSettingsSidebarItemProps(props.cluster);

  return (
    <SidebarItem
      title="Settings"
      url={`${basePath}/settings`}
      rules={[['view', 'ClusterAutoscaler']]}
      rulesConditions={{ clusterId: props.cluster.id }}
      {...sidebarItemProps}
    />
  );
};
